export const checkStripeFetching = ({ stripe: { fetchingData } }) => fetchingData;
